import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./pages/authentication/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Signup from "./pages/authentication/Signup";
import AppLayout from "./components/Layout/AppLayout";
import CategoryManagement from "./components/Layout/CategoryManagement";
import ProtectedRoute from "./components/Layout/ProtectedRoute";
import ResetPassword from "./pages/authentication/ResetPassword";
import ForgotPassword from "./pages/authentication/ForgotPassword";
import Logout from "./pages/authentication/Logout";
import CarCrudModal from "./components/Layout/CarCrudModal";
import CarBooking from "./components/Layout/CarBooking";
import Dashboard from "./components/Layout/Dummy";
import CategoryDetails from "./components/Layout/CategoryDetails";
import CarDetails from "./components/Layout/CarDetails";
import AdminManagement from "./components/Layout/AdminManagement";
import RoleManagement from "./components/Layout/RoleManagement";
import Dummy from "./components/Layout/Dummy";
import HomeCar from "./pages/landing/HomeCar";
import UserLogin from "./pages/auth/UserLogin";
import UserSignup from "./pages/auth/UserSignup";
import AddBookingFormPage from "./pages/landing/AddBookingFormPage";
import ConfirmedBooking from "./pages/landing/ConfirmedBooking";
import CarListingPage from "./pages/landing/CarListingPage";
import MyBooking from "./pages/landing/MyBooking";
import CarDetailsPage from "./pages/landing/CarDetailsPage";
import PublicAppLayout from "./components/landing/PublicAppLayout";
import ProtectedUserRoute from "./components/landing/ProtectedUserRoute";
import OtpVerification from "./pages/auth/OtpVerfication";

import "./index.css";
import "./App.css";
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/admin-login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-Password" element={<ResetPassword />} />
          <Route path="/logout" element={<Logout />} />

          {/* public-user-auth */}

          <Route path="/user-login" element={<UserLogin />} />
          <Route path="/user-signup" element={<UserSignup />} />
          <Route path="/user-otp" element={<OtpVerification />} />

          {/* public-user-routes */}

          <Route path="/" element={<PublicAppLayout />}>
            <Route index element={<HomeCar />} />

            {/* PROTECTED USER PAGES */}

            <Route
              path="booking/confirmed"
              element={
                <ProtectedUserRoute>
                  <ConfirmedBooking />
                </ProtectedUserRoute>
              }
            />
            <Route
              path="booking/add/:id"
              element={
                <ProtectedUserRoute>
                  <AddBookingFormPage />
                </ProtectedUserRoute>
              }
            />
            <Route
              path="booking/myBooking"
              element={
                <ProtectedUserRoute>
                  <MyBooking />
                </ProtectedUserRoute>
              }
            />

            {/* PROTECTED USER PAGES -ends*/}

            <Route path="/booking/carlisting" element={<CarListingPage />} />

            <Route
              path="/booking/carlisting/details/:id"
              element={<CarDetailsPage />}
            />
          </Route>

          {/* admin-routes */}

          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="category" element={<CategoryManagement />} />
            <Route path="admins" element={<AdminManagement />} />
            <Route path="roles" element={<RoleManagement />} />
            <Route path="dashboard" element={<Dummy />} />

            <Route
              path="/admin-dashboard/category/details/:id"
              element={<CategoryDetails />}
            />

            <Route path="cars" element={<CarCrudModal />} />
            <Route
              path="/admin-dashboard/cars/details/:id"
              element={<CarDetails />}
            />

            <Route path="carbooking" element={<CarBooking />} />
          </Route>

          <Route path="*" element={<Login />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}
export default App;
